module.exports = __webpack_public_path__ + "media/images/flags/BO-f4da721ff40dad6eb750d9810aa6c84d.svg";